export default function () {
  var herald_retina_logo_done = false,
    herald_retina_mini_logo_done = false,
    herald_header_center_done = false;

  // Center middle header elements vertically

  if (!herald_header_center_done && $('.header-middle').is(':visible')) {
    imagesLoaded( '.header-middle', function() {
      $('.header-middle .hel-el').children().each(function () {
        $(this).heraldCenter().animate({
          opacity: 1
        }, 100);
      });
    });
    herald_header_center_done = true;
  }

  //Retina logo
  if (window.devicePixelRatio > 1) {
    if (!herald_retina_logo_done && herald_js_settings.logo_retina && $('.herald-logo').length) {
      imagesLoaded( '.herald-logo', function() {
        $('.herald-logo').each(function () {
          if ($(this).is(':visible')) {
            //var height = $(this).height();
            var width = $(this).width();
            $(this).attr('src', herald_js_settings.logo_retina).css('width', width + 'px');
          }
        });
      });
      herald_retina_logo_done = true;
    }
    if (!herald_retina_mini_logo_done && herald_js_settings.logo_mini_retina && $('.herald-logo-mini').length) {
      imagesLoaded( '.herald-logo-mini', function() {
        $('.herald-logo-mini').each(function () {
          if ($(this).is(':visible')) {
            //var height = $(this).height();
            var width = $(this).width();
            $(this).attr('src', herald_js_settings.logo_mini_retina).css('width', width + 'px');
          }
        });
      });
      herald_retina_mini_logo_done = true;
    }
  }
}
